import axios from 'axios';
import Vue from 'vue';

import config from '@/config/config';

// 重新授权
const reauthorize = () => {
	if (config.wechat.oauth()) {
		Vue.prototype.$localStorage.setItem('rurel', window.location.href);
		window.location.replace(config.wechat.oauth());
	}
};

useRequestConfig();
// 配置request请求配置
function useRequestConfig() {
	axios.interceptors.request.use(
		function (options: any) {
			options.headers = {
				Authorization: `Bearer ${Vue.prototype.$localStorage.getItem('token') || ''}`
			};

			if (options.url.indexOf('/schneider-truck-minisite-api/') == -1) {
				options.url = `/schneider-truck-minisite-api${options.url}`;
			}
			if (process.env.VUE_APP_BLUE_DOT === 'develop') {
				// 测试环境区分
				options.url = options.url.replace('/schneider-truck-minisite-api/', '/schneider-truck-minisite-api-dev/');
			}
			return options;
		},
		function (error: any) {
			return Promise.reject(error);
		}
	);

	axios.interceptors.response.use(
		function (response) {
			return response;
		},
		function (error) {
			if (error?.response?.status == 401) {
				// console.log('token过期');
				reauthorize();
			}
			return Promise.reject(error);
		}
	);
}
